import "./App.css";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./layout/PrivateRoute";
import PageNotFound from "./components/other/PageNotFound";
import VisitorEmailPopup from "./components/other/VisitorEmailPopup";
import { AllRoutes } from "./routes/pageRoutes";

function App() {
  return (
    <>
      <Routes>
        {AllRoutes?.map((item, index) => {
          return (
            <Route
              key={index}
              exact
              path={item.path}
              element={
                item?.isPrivate ? (
                  <PrivateRoute>{item?.element}</PrivateRoute>
                ) : (
                  item?.element
                )
              }
            />
          );
        })}
        <Route exact path="*" element={<PageNotFound />} />
      </Routes>
      <VisitorEmailPopup />
    </>
  );
}

export default App;
